import { render, staticRenderFns } from "./AccordionToggle.vue?vue&type=template&id=4c2b3a57&"
import script from "./AccordionToggle.vue?vue&type=script&lang=js&"
export * from "./AccordionToggle.vue?vue&type=script&lang=js&"
import style0 from "./AccordionToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports